import { useI18n } from "@wojo/localization";
import { ConfirmedRequestedGroupMemberTripsFragment } from "generated/graphql";
import React from "react";

type ExtensionRoommatesProps = {
    traveler: ConfirmedRequestedGroupMemberTripsFragment;
};

export const ExtensionRoommates: React.FC<ExtensionRoommatesProps> = ({
    traveler,
}) => {
    const i18n = useI18n("account").account.myGroupMembers.roomingTable;

    const notApplicableFragment = () => {
        return (
            <>
                <span aria-hidden={true}>—</span>
                <span className="visually-hidden">
                    {i18n.notApplicable.l()}
                </span>
            </>
        );
    };

    return (
        <>
            {traveler.extensionRoommates?.length === 0 ? (
                notApplicableFragment()
            ) : (
                <div>
                    {traveler.extensionRoommates?.map((roommate, index) => {
                        return (
                            <span key={index}>
                                {`${roommate.lastName}, ${roommate.firstName}`}
                            </span>
                        );
                    })}
                </div>
            )}
        </>
    );
};
